import {observable, action, runInAction, computed} from 'mobx'
import {json, get} from '../../../../utils/ajax'
import {handleSeerchAndPage, objToValueObj, setStore, ValueObjToObj} from '../../../../utils/Utils'
import {message} from "antd";

class FaultCaseCriteriaMaintenanceStore {

    @observable loading
    @observable list //目录
    @observable page //车系分页
    @observable importReturnData //导入返回值
    @observable editFields //新增修改数据
    @observable option
    @observable optionModal
    @observable addBoxModal
    @observable search //查询
    @observable listRecord //单条查询行信息
    @observable contentBoxModal //添加具体参数信息modal
    @observable contentListPage //内容详情列表
    @observable contentLoading //
    @observable carList // 车系列表明
    @observable fileList // 文件上传
    @observable fileName
    @observable fileUrl
    @observable contentField

    constructor() {
        this.loading = false
        this.list = []
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.importReturnData = []
        this.editFields = {}
        this.option = []
        this.optionModal = ''
        this.addBoxModal = false
        this.search = {
            name: ''
        }
        this.listRecord={}
        this.contentBoxModal=false
        this.contentListPage = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.contentLoading=false
        this.carList=[]
        this.fileList=[]
        this.fileName=''
        this.fileUrl=''
        this.contentField={}
    }

    /** 设置store对象，类似react的setState **/
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /** 初始化页面 **/
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchResult = handleSeerchAndPage(page, this.page, this.search) //多条件分页的轮子
        searchResult.size = this.page.pageSize
        searchResult.name = this.search.keyOrValue
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteria/directoryList`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content || []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }


    /** 新增修改开启模态框 **/
    @action
    showBox = (record, option) => {
        runInAction(() => {
            if (option === 'update') {
                this.editFields = objToValueObj(record)
            } else {
                this.editFields = {}
            }
            this.loading = true
            this.option = option
            this.optionModal = option === 'addSame' ? '新增' : '修改'
            this.addBoxModal = true
            this.loading = false
        })
    }

    @computed
    get fields() {
        let fields = {
            name: {value: this.editFields.name},
        }
        return fields
    }

    //Cast
    @action
    onEditFieldChange(changedFields) {
        this.editFields = {...this.editFields, ...changedFields}
    }

    /** 新增/修改 **/
    @action
    operation = async () => {
        this.loading = true
        if (this.option === 'addSame') {//添加
            let search = {
                name: this.editFields.name ? this.editFields.name.value : '',
            }
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteria/addCatalog`, search)
            if (res && res.status === 0) {
                message.warning('该目录已存在，请勿重新添加!')
                this.loading = false
                return
            }
            message.success(`新增成功！`)
        } else if (this.option === 'update') {//修改
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteria/update`, ValueObjToObj(this.editFields))
            if (res.status) {
                message.success(`修改成功！`)
            } else {
                message.warning(`该目录已存在，请勿重新添加!`)
            }
        }
        runInAction(() => {
            this.loading = false
            this.initListPage()
        })
    }

    /** 删除 **/
    @action
    deleteOne = async (record) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteria/delById/id/${record.id}`)
        runInAction(() => {
            message.success(`删除成功！`)
            this.initListPage()
        })
    }

    /** 将页面的值绑定到store，查询值 **/
    @action
    onSearchFieldChange=(changedFields)=>{
        this.search={...this.search,...ValueObjToObj(changedFields)}
    }


    /** 标准内容维护 **/

    //点击当前行，保存list行Id
    @action
    saveListId=(record)=>{
        this.listRecord=record
        this.initContentListPage()
        this.getCarseries()
    }

    /** 新增修改开启模态框 **/
    @action
    showContentBox = (record, option) => {
        runInAction(() => {
            if (option === '修改') {
                this.contentField = {...objToValueObj(record)}
                this.fileName= record.fileName
                this.fileUrl= record.fileUrl
                this.contenId=record.id
            } else {
                this.contentField = {}
                this.fileName= ''
                this.fileUrl= ''
            }
            this.contentLoading = true
            this.contentBoxTitle = option
            this.contentBoxModal = true
            this.contentLoading = false
        })
    }



    /** 内容维护页面 **/
    @action
    initContentListPage = async (page) => {
        runInAction(() => {
            this.contentLoading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteriaContent/criteriaIdQueryListPaging?criteriaId=${this.listRecord.id}`,this.contentListPage)
        if (res && res.status === 0) {
            runInAction(() => {
                this.contentLoading = false
            })
            return
        }
        runInAction(() => {
            this.contentLoading = false
            this.contentList = res.content || []
            this.contentListPage = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }


//    获取车系列表
    @action
    getCarseries =async()=>{
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCarseries/queryListByPage`)
        runInAction(()=>{
            this.carList = res.content
        })
    }


    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
        if (info.file.status === 'uploading') {
            runInAction(() => {
                this.upLoading = true
            })
            return
        }
        if (info.file.status === 'done') {
            runInAction(() => {
                let fileList = [...info.fileList];
                this.fileList =fileList.slice(-1)[0];
                this.fileName = this.fileList.name
                this.fileUrl = this.fileList.response
                this.upLoading = false
            })
            return
        }
        if (info.file.status === 'error') {
            runInAction(() => {
                this.upLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }


    //Cast
    @action
    onContentFieldChange(changedFields) {
        this.contentField = {...this.contentField, ...changedFields}
    }

    /** 新增/修改 **/
    @action
    editContent = async () => {
        if (this.contentBoxTitle === '新增') {//添加
            let obj = {
                carseries:this.contentField.carseries.value,
                parameterName:this.contentField.parameterName.value,
                criteriaId:this.listRecord.id,
                fileName:this.fileName,
                fileUrl:this.fileUrl
            }
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteriaContent/add`, obj)
            if (res && res.status === 1) {
                message.success(`新增成功！`)
                runInAction(()=>{
                    this.contentBoxModal=false
                    this.initContentListPage()
                })
            }
        } else if (this.contentBoxTitle === '修改') {//修改
            let obj = {
                carseries:this.contentField.carseries.value,
                parameterName:this.contentField.parameterName.value,
                criteriaId:this.listRecord.id,
                fileName:this.fileName,
                fileUrl:this.fileUrl,
                id:this.contenId
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteriaContent/update`, obj)
            if (res.status) {
                message.success(`修改成功！`)
                runInAction(()=>{
                    this.contentBoxModal=false
                    this.initContentListPage()
                })
            }
        }
    }

    //删除
    @action
    deleteContentListOne=async(record)=>{
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultCaseCriteriaContent/delById/id/${record.id}`)
          if(res.status){
                runInAction(() => {
                    message.success(`删除成功！`)
                    this.initContentListPage()
                })
            }
    }


}

export default new FaultCaseCriteriaMaintenanceStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/FaultDiagnosis/FaultCaseCriteriaMaintenance/store.js